import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SYSTEM_SETTINGS_ACTION_TYPE } from '../actions';

const initialState = {};

const settingsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case SYSTEM_SETTINGS_ACTION_TYPE.GET_SYSTEM_SETTINGS:
        return payload || initialState;

      case SYSTEM_SETTINGS_ACTION_TYPE.CREATE_SYSTEM_SETTING:
      case SYSTEM_SETTINGS_ACTION_TYPE.EDIT_SYSTEM_SETTING:
        draft[payload.applicationSettingId] = payload;
        break;

      case SYSTEM_SETTINGS_ACTION_TYPE.DELETE_SYSTEM_SETTING:
        delete draft[meta.applicationSettingId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default settingsReducer;
